import { useState } from 'react';
import { CoreBox, CoreTypography } from '@youscience/core';
import { UserCertificationProduct } from '@common-types';

import { Container } from '@components/Layout/components/Container';
import { CertificationCard } from '@components/CertificationCard';
import { CertificationCardSkeleton } from '@components/CertificationCard/CertificationCardSkeleton';

import ShowMoreIcon from '@images/show-more.svg?react';
import ShowLessIcon from '@images/show-less.svg?react';

import { sxStyles } from './RelatedCertifications.styles';

interface RelatedCertificationsProps {
  relatedCertifications: UserCertificationProduct[];
  isDataLoading?: boolean;
}

const MAX_CERTIFICATIONS_COUNT = 5;

const cardSkeletonsList = Array.from({ length: 5 }, (index, id) => <CertificationCardSkeleton key={id} />);

export const RelatedCertifications = (props: RelatedCertificationsProps) => {
  const { relatedCertifications = [], isDataLoading } = props;

  const [isShowMore, setIsShowMore] = useState(false);

  if (!relatedCertifications.length) return null;

  const showBtnText = isShowMore ? 'Show less' : 'Show more';
  const shortCertificationList = relatedCertifications.slice(0, MAX_CERTIFICATIONS_COUNT);
  const certificationList = isShowMore ? relatedCertifications : shortCertificationList;

  const handleShowBtn = () => {
    setIsShowMore((prevState) => !prevState);
  };

  return (
    <Container>
      <CoreTypography sx={sxStyles.relatedCertificationsTitle} component="h3" variant="h4">
        Related YouScience Certifications
      </CoreTypography>

      {isDataLoading
        ? cardSkeletonsList
        : certificationList.map((certification) => {
            return <CertificationCard key={certification.productNumber} certification={certification} />;
          })}

      {relatedCertifications.length > MAX_CERTIFICATIONS_COUNT && (
        <CoreBox sx={sxStyles.showBtnWrap}>
          <CoreBox sx={sxStyles.showBtn} onClick={handleShowBtn}>
            {isShowMore && <ShowLessIcon />}

            <CoreTypography sx={sxStyles.showTextBtn}>{showBtnText}</CoreTypography>

            {!isShowMore && <ShowMoreIcon />}
          </CoreBox>
        </CoreBox>
      )}
    </Container>
  );
};
